import React from "react";
import Header, { HeaderLeft } from "../../../layout/Header/Header";
import CommonHeaderRight from "./CommonHeaderRight";

const ManageFlatsHeader = () => {
  return (
    <Header>
      <HeaderLeft>
        <div>
          <div className="fw-bold fs-6 mb-0">Manage All Flats</div>
          <div className="text-muted">
            <small>
              Easily upload your entire building directory via CSV, or use the
              table below to edit and remove individual house records.
            </small>
          </div>
        </div>
      </HeaderLeft>
      <CommonHeaderRight />
    </Header>
  );
};

export default ManageFlatsHeader;
